import { QuestionDto } from '@maia/shared';
import { match, P } from 'ts-pattern';

type InputTypes = QuestionDto['inputType'];
const INPUT_WITH_OPTIONS_ARRAY: Array<InputTypes> = [
  'toggle_group',
  'radio',
  'question',
  'multiple_choice',
];
const INPUT_WITH_OPTIONS_TUPAL: Array<InputTypes> = ['switch'];

const isInputWithOptionsArray = (inputType: InputTypes) =>
  INPUT_WITH_OPTIONS_ARRAY.includes(inputType);

const isInputWithOptionsTupal = (inputType: InputTypes) =>
  INPUT_WITH_OPTIONS_TUPAL.includes(inputType);

export const mapQuestionToFieldProps = (question: QuestionDto) => {
  return match(question)
    .with({ inputType: 'dropdown' }, (q) => ({
      label: q.phrasing,
      description: q.description,
      name: q.guid,
      moreInfo: q.moreInformation,
      items: q.options.map((o) => ({
        label: o.label,
        value: o.value,
        meta: {},
      })),
    }))
    .with({ inputType: P.when(isInputWithOptionsArray) }, (q) => ({
      label: q.phrasing,
      description: q.description,
      name: q.guid,
      moreInfo: q.moreInformation,
      options: q.options,
    }))
    .with({ inputType: P.when(isInputWithOptionsTupal) }, (q) => ({
      label: q.phrasing,
      description: q.description,
      name: q.guid,
      moreInfo: q.moreInformation,
      options: q.options,
    }))
    .with({ inputType: 'attachments' }, (q) => ({
      label: q.phrasing,
      description: q.description,
      name: q.guid,
      moreInfo: q.moreInformation,
    }))
    .otherwise(() => ({
      label: question.phrasing,
      description: question.description,
      name: question.guid,
      moreInfo: question.moreInformation,
      value: question.answer.value,
    }));
};
